export const DELAY_BETWEEN_INPUT = 2000
